package dairy.mynotes.reusablecomponents

import androidx.annotation.Size
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import dairy.mynotes.ui.theme.AppColors

@Composable
fun RoundedBox(modifier: Modifier= Modifier,size: Dp = 120.dp,roundedCornerSize:Dp  = 20.dp,
               backGroundColor: Color = AppColors.LightGray,
               contentAlignment: Alignment = Alignment.Center,
               content: @Composable () -> Unit
) {

    Box(modifier = Modifier.size(size)
        .clip(shape = RoundedCornerShape(roundedCornerSize))
        .background(backGroundColor)
        .padding(16.dp),
        contentAlignment = contentAlignment
    ){
        content()
    }
}
